import React from "react";
import { ServicePage } from "@/components/ServicePage";
import { ServerExplainers } from "@/components/explainers/ServerExplainers";

export const ManagedServer = () => (
  <ServicePage
    slotAfterFeatures={<ServerExplainers />}
    testIdSlug="managed-server"
    seo={{
      title: "Managed Server Hosting · Windows Server mieten",
      description: "Managed Server Hosting aus deutschen Rechenzentren. Windows & Linux Server günstig mieten – inklusive Admin-Rechten, KVM-Virtualisierung und 24/7 Support.",
      keywords: "Managed Server, Windows Server mieten, Server Hosting Deutschland, KVM Virtualisierung, Cloud Server Hessen, Hosted Exchange",
      serviceName: "Managed Server Hosting",
      breadcrumb: [
        { name: "Start", path: "/" },
        { name: "Managed Server", path: "/managed-server" },
      ],
    }}
    eyebrow="Managed Server Hosting"
    title="IT-Infrastruktur für nachhaltiges Wachstum."
    subtitle="Windows Server günstig mieten, volle Admin-Rechte, KVM-Virtualisierung – inklusive Verwaltung, Wartung und 24/7 Support."
    heroImage="/wp-images/managed-server.jpg"
    features={[
      { title: "Schnelle Skalierung", desc: "Serverkapazität flexibel an wachsende Anforderungen anpassen." },
      { title: "Höchste Sicherheit", desc: "Modernste Sicherheitsstandards für Ihre Daten – Firewall, Patches, Audits." },
      { title: "24/7 Support", desc: "Unser Experten-Team steht rund um die Uhr für Sie bereit." },
      { title: "Zuverlässige Performance", desc: "Konstant hohe Verfügbarkeit und Geschwindigkeit – garantiert." },
      { title: "Servermanagement", desc: "Installation, Konfiguration, Überwachung und Updates – alles inklusive." },
      { title: "Datenbankverwaltung", desc: "Individuelle Lösungen für die perfekte Organisation Ihrer Daten." },
    ]}
    bullets={[
      "Windows & Linux Server verfügbar",
      "KVM-basierte Virtualisierung",
      "Kostenfreie Upgrade-Möglichkeit",
      "Backup-Lösungen integriert",
      "Online-Shops & Mail-Server geeignet",
      "Hosting in deutschen Rechenzentren",
    ]}
    longText={[
      "<strong>Managed Server Hosting</strong> ist eine leistungsstarke IT-Lösung, die Unternehmen eine zuverlässige und skalierbare Infrastruktur bietet. Wir übernehmen die vollständige Verwaltung und Wartung Ihrer Server, damit Sie sich auf Ihr Kerngeschäft konzentrieren können.",
      "Dazu gehören Installation, Konfiguration, Überwachung und regelmäßige Updates der Server-Software. Fortschrittliche Sicherheitsmaßnahmen wie Firewalls, regelmäßige Backups und Sicherheitsupdates schützen Ihre Daten vor Cyberangriffen.",
      "Durch redundante Systeme und 24/7-Support stellen wir sicher, dass Ihre Anwendungen und Daten jederzeit verfügbar sind – ideal für Unternehmen mit kontinuierlicher Online-Präsenz.",
    ]}
  />
);
